import { jsx as _jsx } from "react/jsx-runtime";
import { Projects, useResources } from '../resources';
export const DriftspanelContainer = () => {
    const resources = useResources(Projects.FRAMEWORK);
    return _jsx("hn-webcomp-driftspanel", { arialabel: resources?.driftspanel_aria_label });
};
export default DriftspanelContainer;
